const ModalWrapper = ({ children = [] }) => <div className="modal__wrapper">{children}</div>;

export default ModalWrapper;
